import { $, _, Backbone, Radio, Datepicker } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import Inboomai18n from "../../utils/Inboomai18n";

// fullcalendar locales werden dynamisch via globals.js geladen
import OrdersCalendarViewTpl from "../../templates/orders/OrdersCalendarViewTpl.html";

/**
 * Displays a simple fullcalendar that interacts with
 * the filterable parent-view-collection
 */
export default InboomaBaseView.extend({
  template: OrdersCalendarViewTpl,
  el: "#inb-c-main-orders",

  initialize() {
    $(".inb-next-page-button").hide();

    this.app = Radio.channel("app");

    // collection = proxy!!!
    this.listenTo(this.collection, "add", this._addOne);
    this.listenTo(this.collection, "remove", this._removeOne);

    this.render();
  },

  _addOne(event) {
    event.set("start", event.get("begin"));
    console.log("add event", event.toJSON());
    this.fc.fullCalendar("renderEvent", event.toJSON(), true);
  },

  _removeOne(event) {
    console.log("remove event", event);
    this.fc.fullCalendar("removeEvents", event.get("id"));
  },

  onDestroy() {
    // collection.off(*)
    alert("destroy view");
  },

  onRender() {
    console.log("calendar render");
    const that = this,
      users = Radio.channel("users").request("get:data"), // this is only enough for clients with less than 100 users (page limit of user pagination)
      lang = this.app.request("get:settings")["language"];
    let userRequests = 0; // number of currently active user requests, needed to determine if a re-render is necessary

    $("#inb-c-main-sort-nav").addClass("hide");

    this.fc = this.$el.find("#calendar");
    this._calendarEvents = [];

    _.each(this.collection.models, (order, key) => {
      if (order.get("status") == "cancelled") {
        return;
      }

      _.each(order.get("reservations").models, (reservation) => {
        if (reservation.get("status") != "cancelled") {
          const that = this;
          let user = users.get(order.get("user_id"));

          const addCalendarEvent = (
            events,
            reservation,
            user,
            shouldRender,
          ) => {
            if (typeof reservation.get("title") == "undefined") {
              reservation.set("start", reservation.get("begin"));
              reservation.set(
                "title",
                " - " +
                  (user.get("first_name") === undefined
                    ? "?"
                    : user.get("first_name")) +
                  " " +
                  user.get("last_name"),
              );
            }

            events.push(reservation.toJSON());
            if (shouldRender) that.render();
          };

          if (_.isUndefined(user)) {
            // request user, increment number of currently active user requests
            userRequests++;
            users.fetchById(order.get("user_id"), function (_user) {
              if (_user === undefined || _user == null) {
                // user not existing
                user = { get: function () {} };
              } else {
                user = _user;
              }
              userRequests--;
              addCalendarEvent(
                that._calendarEvents,
                reservation,
                user,
                userRequests == 0,
              );
            });
          } else {
            addCalendarEvent(that._calendarEvents, reservation, user, false);
          }
        }
      });
    });

    //console.log('events',that._calendarEvents);

    this.fc.fullCalendar({
      locale: lang == "de_DE" ? "de" : "en",
      displayEventEnd: true,
      timeFormat: "HH:mm",
      header: {
        left: "prev,next today",
        center: "title",
        right: "",
      },
      selectable: true,
      viewRender(view, container) {
        $(".fc-button")
          .addClass("button")
          .addClass("secondary")
          .addClass("hollow");

        $("a.fc-day-number").removeAttr("data-goto");
      },
      select(start, end) {
        start = start.format("D. MMMM YYYY");
        end = end.format("D. MMMM YYYY");

        /*if (confirm(that.t('add_${a}',{a:that.t('reservation')}) + ' ' + that.t('from') + ' ' + start + ' ' + that.t('till') + ' ' + end + '?')) {
          Backbone.history.navigate('orders/add'); // ?start=start&end=end
        }*/
      },
      eventClick(event) {
        if (event.order_id) {
          Backbone.history.navigate(
            "orders/" + event.order_id + "/edit/" + event.id,
            { trigger: true },
          );
        }
      },
      navLinks: true,
      editable: false,
      eventLimit: true, // allow "more" link when too many events
      events: that._calendarEvents,
    });

    const datepicker = new Datepicker({
      field: that.$el.find(".fc-center h2")[0],
      i18n: Inboomai18n.getPikadayI18n(),
      firstDay: 1, // monday
      onSelect(date) {
        that.fc.fullCalendar("gotoDate", date);
        //eventsCollection.refetchEvents();
      },
      onOpen() {
        datepicker.setMoment(that.fc.fullCalendar("getDate"));
        // @Deprecated: $('.pika-select-month').trigger('click');
      },
    });

    this.$el
      .find("#calendar-header-left")
      .show()
      .appendTo("#calendar .fc-left")
      .find("input")
      .val("");
    this.$el
      .find("#calendar-header-right")
      .show()
      .appendTo("#calendar .fc-right");
  },
});
